/**
 * Flumen's SEND_TIME is Europe/Belgrade wall-clock time with no zone
 * suffix (verified 2026-09-04: SEND_TIME 17:11:32 when UTC was 15:11).
 * Everything that turns a SEND_TIME into an epoch, or an epoch back into a
 * Flumen query bound, goes through here.
 *
 * DST fall-back hour (ambiguous 02:00–03:00 once a year): dayjs.tz picks
 * the first occurrence. Accepted.
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const STATION_TZ = 'Europe/Belgrade';
const WALL_FMT = 'YYYY-MM-DD HH:mm:ss';

const WALL_RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

export function parseStationTime(wall) {
    if (typeof wall !== 'string' || !WALL_RE.test(wall)) return NaN;
    try {
        const d = dayjs.tz(wall, WALL_FMT, STATION_TZ);
        return d.isValid() ? d.valueOf() : NaN;
    } catch (e) {
        // dayjs.tz throws (Intl RangeError) on impossible dates like 2026-13-40.
        return NaN;
    }
}

export function toStationWall(ms, fmt = WALL_FMT) {
    return dayjs(ms).tz(STATION_TZ).format(fmt);
}

export function formatStationTime(ms, fmt) {
    return toStationWall(ms, fmt);
}

const MONTH_LOCALES = { en: 'en-GB', sr: 'sr-Latn', src: 'sr-Cyrl' };
/**
 * "2019-06" → "Jun 2019" / "jun 2019" / "јун 2019" for the app language (en | sr | src).
 * Used for the "archive since" note; Serbian Intl output carries a trailing period that we strip.
 */
export function formatMonthYear(yyyyMm, lang = 'en') {
    if (!yyyyMm || !/^\d{4}-\d{2}$/.test(yyyyMm)) return null;
    const [y, m] = yyyyMm.split('-').map(Number);
    const text = new Intl.DateTimeFormat(MONTH_LOCALES[lang] || MONTH_LOCALES.en, { month: 'short', year: 'numeric' }).format(new Date(y, m - 1, 1));
    return text.replace(/\.$/, '');
}
